var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgIconLockBlack = function SvgIconLockBlack(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.3334 11.6667V15H15.6667V11.6667C15.6667 9.27347 17.6068 7.33337 20.0001 7.33337C22.3933 7.33337 24.3334 9.27347 24.3334 11.6667ZM6.66675 21C6.66675 18.027 8.82903 15.5591 11.6667 15.083V11.6667C11.6667 7.06433 15.3977 3.33337 20.0001 3.33337C24.6025 3.33337 28.3334 7.06433 28.3334 11.6667V15.083C31.1711 15.5591 33.3334 18.027 33.3334 21V30.6667C33.3334 33.9804 30.6471 36.6667 27.3334 36.6667H12.6667C9.35303 36.6667 6.66675 33.9804 6.66675 30.6667V21ZM20.0001 21.6667C19.0796 21.6667 18.3334 22.4129 18.3334 23.3334V28.3334C18.3334 29.2538 19.0796 30 20.0001 30C20.9206 30 21.6667 29.2538 21.6667 28.3334V23.3334C21.6667 22.4129 20.9206 21.6667 20.0001 21.6667Z",
    fill: "#7A7A7A"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgIconLockBlack);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "apps/static/media/icon-lock-black.3c7b544ad75c9e82f230b0ec5a0e03bb.blank.svg";